module.exports = __webpack_public_path__ + "static/img/three_icon_4.f0475159.png";